<script setup lang="ts">
  import { DefaultTable, TableHeader, HeaderTableWithButtons, SearchNoResults } from '@/shared/ui';
  import VerificationTableRow from './VerificationTableRow.vue';
  import { useTableEvents, useTableState, type TableEmitter } from '@/shared/lib';
  import type { DocumentRevision } from '@/entities/Document';
  import type { OrderOptions, HeaderEmits } from '@/shared/lib';

  const props = withDefaults(
    defineProps<{
      revisions: DocumentRevision[];
      error?: string | null;
      page: number;
      orderOptions?: OrderOptions[];
      isFilterActive?: boolean;
      codeColumnLabel?: string;
    }>(),
    {
      codeColumnLabel: 'Prefixo',
    }
  );

  const emit = defineEmits<HeaderEmits>();

  const { handleSortOptions, handleFilter } = useTableEvents(emit as TableEmitter);

  const handleFilterClicked = () => {
    emit('filter-clicked');
  };

  const { shouldShowError, shouldShowEmpty } = useTableState<DocumentRevision>({
    error: () => props.error,
    data: () => props.revisions,
    errorMessage: 'Erro ao carregar verificações',
  });

  const VERIFICATION_TABLE_COLUMN_COUNT = 7;
</script>

<template>
  <DefaultTable class="divide-y divide-gray-02">
    <thead>
      <tr>
        <HeaderTableWithButtons
          id="header-table-with-buttons"
          :colspan="VERIFICATION_TABLE_COLUMN_COUNT"
          text="Verificações pendentes"
          :order-options="orderOptions"
          :is-filter-active="isFilterActive"
          @update:sort="handleSortOptions"
          @update:filter="handleFilter"
          @filter-clicked="handleFilterClicked"
        />
      </tr>
      <tr v-if="revisions.length">
        <TableHeader text="Data da solicitação" class="text-sm/5 pl-6 py-4.5 pr-3" />
        <TableHeader :text="codeColumnLabel" class="text-sm/5 whitespace-nowrap" />
        <TableHeader text="Título" class="text-sm/5" />
        <TableHeader text="Rev." class="text-sm/5" />
        <TableHeader text="Elaboração" class="text-sm/5" />
        <TableHeader text="Aprovação" class="text-sm/5" />
        <TableHeader text="" class="text-sm/5 w-14" />
      </tr>
    </thead>
    <tbody class="bg-white-01 divide-y divide-gray-02">
      <tr v-if="shouldShowError">
        <td :colspan="VERIFICATION_TABLE_COLUMN_COUNT" class="text-center py-4 text-gray-07">
          Erro ao carregar verificações
        </td>
      </tr>
      <tr v-else-if="shouldShowEmpty">
        <td :colspan="VERIFICATION_TABLE_COLUMN_COUNT" class="py-8">
          <SearchNoResults />
        </td>
      </tr>
      <template v-if="!shouldShowError && !shouldShowEmpty">
        <VerificationTableRow
          v-for="verification in revisions"
          :key="verification.id"
          :verification="verification"
        />
      </template>
    </tbody>
  </DefaultTable>
</template>
